import { tw } from "~/utils";

type Direction = "left" | "right" | "up" | "down";

export interface ArrowIconProps {
  className?: string;
  direction?: Direction;
}

export const ArrowIcon = ({
  className,
  direction = "left",
}: ArrowIconProps) => {
  const directionClasses = {
    left: "",
    right: "transform rotate-180",
    up: "transform rotate-90",
    down: "transform -rotate-90",
  };

  return (
    <svg
      width="13"
      height="11"
      viewBox="0 0 13 11"
      fill="currentColor"
      className={tw("size-4", directionClasses[direction], className)}
    >
      <path
        d="M-0.00449799 5.49981C-0.004498 5.3009 0.0745196 5.11014 0.215172 4.96948C0.355825 4.82883 0.546589 4.74981 0.745502 4.74981L9.933 4.74981L6.713 1.53044C6.57211 1.38954 6.49295 1.19844 6.49295 0.999187C6.49295 0.799929 6.57211 0.608833 6.713 0.467937C6.8539 0.32704 7.04499 0.247885 7.24425 0.247885C7.44351 0.247885 7.63461 0.32704 7.7755 0.467937L12.2755 4.96794C12.3454 5.03761 12.4009 5.12041 12.4388 5.21157C12.4766 5.30274 12.4961 5.40048 12.4961 5.49919C12.4961 5.5979 12.4766 5.69564 12.4388 5.7868C12.4009 5.87796 12.3454 5.96076 12.2755 6.03044L7.7755 10.5304C7.70574 10.6002 7.62292 10.6555 7.53176 10.6933C7.44061 10.7311 7.34292 10.7505 7.24425 10.7505C7.14559 10.7505 7.04789 10.7311 6.95674 10.6933C6.86559 10.6555 6.78277 10.6002 6.713 10.5304C6.64324 10.4607 6.5879 10.3779 6.55014 10.2867C6.51238 10.1955 6.49295 10.0979 6.49295 9.99919C6.49295 9.90053 6.51238 9.80283 6.55014 9.71168C6.5879 9.62053 6.64324 9.5377 6.713 9.46794L9.933 6.24981L0.745502 6.24981C0.546589 6.24981 0.355825 6.1708 0.215172 6.03014C0.0745197 5.88949 -0.00449797 5.69872 -0.00449799 5.49981Z"
        fill="black"
      />
    </svg>
  );
};
